{
  "name": "@ns/select-company-to-transfer-node-cash",
  "version": "1.0.0",
  "description": " Select a company to transfer node cash to",
  "inputs": {},
  "outcomes": {
    "complete": {
      "inputs": {
        "recipientCompanyId": {
          "type": "string",
          "ref": "company"
        }
      }
    }
  }
}
